import cl from "clsx";
import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@navikt/aksel-icons";
function ScrollButton({ hidden, onClick, dir }) {
    return (React.createElement("div", { className: cl("navds-tabs__scroll-button", {
            "navds-tabs__scroll-button--hidden": hidden,
        }), onClick: onClick, "aria-hidden": true }, dir === "left" ? (React.createElement(ChevronLeftIcon, { title: "scroll tilbake" })) : (React.createElement(ChevronRightIcon, { title: "scroll neste" }))));
}
export default ScrollButton;
//# sourceMappingURL=ScrollButtons.js.map